
import {Beneficiaire} from '../beneficiaire/beneficiaire.model';
import {Article} from '../article/article.model';
import {Timestampable} from '../ressources/timestampable.model';
import {LineFolders} from './lineFolder.interface';
import LineFolderInterface = LineFolders.LineFolderInterface;

export class LineFolder implements LineFolderInterface, Timestampable {
  id?: number;
  quantite?: number;
  article?: Article;
  beneficiaire?: Beneficiaire;
  rsfDateFacture?: string;
  rsfNombreUniteFacture?: number;
  rsfNombreUnitePrisEnCompte?: number;
  rsfMontantUniteFacture?: number;
  rsfMontantUnitePrisEnCompte?: number;
  rsfTotalUnitesPresente?: number;
  rsfTotalUnitesPrisEnCompte?: number;
  rsfMontantFacture?: number;
  rsfMontantFacturePrisEnCompte?: number;
  reference?: string;
  rsfNomFournisseur?: string;
  subventionUnitaireTheorique?: number;
  subvention?: number;
  subventionTheorique?: number;
  libelle?: string;
  statutAdministratif: LineFolders.StatutAdministratifEnum;
  montant?: number;

  // Timestampable
  creeLe: Date | null;
  majLe: Date | null;
  setCreeLe: (date: string) => void;
  setMajLe: (date: string) => void;

  constructor({
                id = null,
                quantite = null,
                article = null,
                beneficiaire = null,
                rsfDateFacture = null,
                rsfNombreUniteFacture = null,
                rsfNombreUnitePrisEnCompte = null,
                rsfMontantUniteFacture = null,
                rsfMontantUnitePrisEnCompte = null,
                rsfMontantFacture = null,
                rsfMontantFacturePrisEnCompte = null,
                rsfTotalUnitesPresente = null,
                rsfTotalUnitesPrisEnCompte = null,
                reference = null,
                rsfNomFournisseur = null,
                subventionUnitaireTheorique = null,
                subvention = null,
                subventionTheorique = null,
                libelle = null,
                statutAdministratif = LineFolders.StatutAdministratifEnum.Attente,
                montant = null
              }: LineFolderInterface) {
    this.id = id;
    this.quantite = quantite;
    this.article = article;
    this.beneficiaire = beneficiaire;
    this.rsfDateFacture = rsfDateFacture;
    this.rsfNombreUniteFacture = rsfNombreUniteFacture;
    this.rsfNombreUnitePrisEnCompte = rsfNombreUnitePrisEnCompte;
    this.rsfMontantUniteFacture = rsfMontantUniteFacture;
    this.rsfMontantUnitePrisEnCompte = rsfMontantUnitePrisEnCompte;
    this.rsfMontantFacture = rsfMontantFacture;
    this.rsfMontantFacturePrisEnCompte = rsfMontantFacturePrisEnCompte;
    this.rsfTotalUnitesPresente = rsfTotalUnitesPresente;
    this.rsfTotalUnitesPrisEnCompte = rsfTotalUnitesPrisEnCompte;
    this.reference = reference;
    this.rsfNomFournisseur = rsfNomFournisseur;
    this.subventionUnitaireTheorique = subventionUnitaireTheorique;
    this.subvention = subvention;
    this.subventionTheorique = subventionTheorique;
    this.libelle = libelle;
    this.statutAdministratif = statutAdministratif;
    this.montant = montant;
  }
}



// WEBPACK FOOTER //
// ./src/shared/models/folder/lineFolder.model.ts